/* ── dds-bundle-selector-b.js ── */
/* Varianta B: rânduri selectabile, un singur ATC */

(function () {
  function formatMoney(cents) {
    return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' Lei';
  }

  function init() {
    var container = document.querySelector('.dds-bsel');
    if (!container) return;

    var rows = container.querySelectorAll('.dds-bsel__row');
    var basePrice = parseInt(container.dataset.price) || 0;
    var baseCompare = parseInt(container.dataset.compare) || 0;

    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        /* Deselect all */
        rows.forEach(function (r) { r.classList.remove('is-selected'); });
        this.classList.add('is-selected');

        var tier = parseInt(this.dataset.qty) || 1;
        var days = tier * 30;
        var finalPrice = parseInt(this.dataset.price) || 0;
        var totalCompare = parseInt(this.dataset.compare) || 0;
        var productId = this.dataset.productId;
        var variantId = this.dataset.variantId;
        var cartQty = parseInt(this.dataset.cartQty) || 1;

        /* Update components-per-unit on container for Worker discount calculation */
        var rowCompsCount = this.dataset.rowComponentsCount;
        if (rowCompsCount) {
          container.dataset.componentsPerUnit = rowCompsCount;
        }

        /* Persist selection */
        try { sessionStorage.setItem('dds-bsel-qty', tier); } catch(e) {}
        var transport = finalPrice >= 13900 ? 0 : 1500;

        /* Update main form variant ID and quantity */
        var mainForm = document.getElementById('dds-v2-add-form');
        if (mainForm) {
          var mainVariantInput = mainForm.querySelector('input[name="id"]');
          if (mainVariantInput && variantId) mainVariantInput.value = variantId;
        }
        var mainQty = document.getElementById('v2-qty-inp');
        if (mainQty) mainQty.value = cartQty;

        /* Update sticky bar variant ID and quantity */
        var stickyForm = document.getElementById('sticky-product-form');
        if (stickyForm) {
          var stickyVariantInput = stickyForm.querySelector('input[name="id"]');
          if (stickyVariantInput && variantId) stickyVariantInput.value = variantId;
          var stickyQty = stickyForm.querySelector('input.sticky-product-qty');
          if (stickyQty) stickyQty.value = cartQty;
        }
        var stickySelect = document.querySelector('.dds-sticky-bar__select');
        if (stickySelect) {
          stickySelect.value = tier;
        }

        /* Update dynamic checkout qty */
        var dynQty = document.getElementById('dds-v2-dynamic-qty');
        if (dynQty) dynQty.value = cartQty;

        /* Update Quick Form product & variant ID */
        var qfProductInput = document.getElementById('qf-product-id');
        if (qfProductInput && productId) qfProductInput.value = productId;
        var qfVariantInput = document.getElementById('qf-variant-id');
        if (qfVariantInput && variantId) qfVariantInput.value = variantId;

        /* Update page subtitle with capsule count & unit of measure dynamically */
        var capsuleCount = this.dataset.capsuleCount;
        var unitateMasura = this.dataset.unitateMasura;
        var subtitleEl = document.querySelector('.dds-v2-subtitle');
        if (subtitleEl && unitateMasura) {
          if (/\d/.test(unitateMasura)) {
            subtitleEl.textContent = 'Doza de Sănătate, ' + unitateMasura;
          } else if (capsuleCount) {
            subtitleEl.textContent = 'Doza de Sănătate, ' + capsuleCount + ' ' + unitateMasura;
          }
        }

        /* DYNAMIC DESCRIPTION UPDATE: "Pachetul pentru X de zile conține:" + exact component list from row */
        var listHtml = this.dataset.componentsListHtml;
        var strongEls = document.querySelectorAll('.dds-v2-acc-content strong, .dds-v2-main strong, .dds-v2-description strong, p strong');
        strongEls.forEach(function (st) {
          var txt = st.textContent.trim();
          if (txt.indexOf('Pachetul') !== -1 && txt.indexOf('conține') !== -1) {
            st.textContent = 'Pachetul pentru ' + days + ' de zile conține:';
            var pParent = st.closest('p');
            if (pParent && pParent.nextElementSibling && pParent.nextElementSibling.tagName === 'UL') {
              if (listHtml) {
                pParent.nextElementSibling.innerHTML = listHtml;
              }
            }
          }
        });

        /* Update Quick Form fields */
        var titleEl = document.querySelector('.dds-v2-title');
        var productTitle = titleEl ? titleEl.innerHTML.replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim() : 'Produs';
        var label = productTitle;
        var priceStr = formatMoney(finalPrice);

        var fields = {
          'qf-produs': label,
          'qf-pret': priceStr,
          'qf-summary-produs': label,
          'qf-summary-pret': priceStr,
          'qf-summary-total': formatMoney(finalPrice + transport),
          'qf-summary-shipping': transport === 0 ? 'Gratuit' : '15,00 lei'
        };
        for (var id in fields) {
          var el = document.getElementById(id);
          if (!el) continue;
          if (el.tagName === 'INPUT' || el.tagName === 'SELECT') {
            el.value = fields[id];
          } else {
            el.textContent = fields[id];
          }
        }

        var pretVechi = document.getElementById('qf-summary-pret-vechi');
        if (pretVechi && totalCompare > 0) {
          pretVechi.textContent = formatMoney(totalCompare);
          pretVechi.style.display = 'inline';
        }
        var saveBadge = document.getElementById('qf-summary-save-badge');
        var savings = totalCompare - finalPrice;
        if (saveBadge && savings > 0) {
          saveBadge.textContent = 'Economisești ' + Math.floor(savings / 100) + ' Lei';
          saveBadge.style.display = 'inline-flex';
        }

        /* Update days badge */
        var daysBadge = document.getElementById('qf-summary-days-badge');
        if (daysBadge) {
          var baseDays = parseInt(daysBadge.dataset.baseDays) || 30;
          var totalDays = baseDays * tier;
          daysBadge.textContent = 'Pentru ' + totalDays + (totalDays >= 20 ? ' de zile' : ' zile');
        }

        /* Call price update if exists */
        if (typeof window.ddsV2UpdatePrice === 'function') {
          window.ddsV2UpdatePrice();
        }

        /* Update QF summary components */
        var compsText = this.dataset.componentsText;
        var compsEl = document.getElementById('qf-summary-components');
        if (compsEl && compsText) {
          compsEl.innerHTML = compsText;
        }
      });
    });

    /* Sync sticky bar select with row selection */
    var stickySelect = document.querySelector('.dds-sticky-bar__select');
    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        var val = this.value;
        var targetRow = container.querySelector('.dds-bsel__row[data-qty="' + val + '"]');
        if (targetRow) targetRow.click();
      });
    }

    /* Restore saved selection or use default — delay to ensure QF DOM is ready */
    setTimeout(function() {
      var savedQty = null;
      try { savedQty = sessionStorage.getItem('dds-bsel-qty'); } catch(e) {}
      var targetRow = savedQty
        ? container.querySelector('.dds-bsel__row[data-qty="' + savedQty + '"]')
        : null;
      if (!targetRow) targetRow = container.querySelector('.dds-bsel__row.is-selected');
      if (targetRow) targetRow.click();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
